<template>
  <dialog-box padding-off modal persistent full-screen v-model="$root.deviceEmulator" @dismiss="onDismiss" :title="$lang.deviceEmulator" :title-bg-color="$root.colors.primary" :title-bg-color-lightness="$root.colors.bgColorLightness" :title-divider="false" :class="[baseCss]">
    <template v-slot:content>
      <table-layout equal-cells y-align="middle" x-align="center" :class="[bgColor]">
        <row>
          <cell :class="['p-1', 'px-3', 'whitespace-nowrap', 'select-none']">
            <dropdown
              dense
              v-model="device"
              width="185px"
              ref="device"
              @input="onDeviceInput"
              :color="$dark ? 'white' : 'black'"
              :title="$lang.dimensions"
              icon="cellphone-link"
              items-max-height="200px"
              :items="devices" /><!--
              --><span
            :class="['inline-block', 'align-middle', 'text-xs', 'truncate', 'mx-2']">{{ width }} x {{ height }}</span><!--
            --><dropdown
            dense
            v-model="zoom"
            icon="loupe"
            items-max-height="200px"
            width="106px"
            ref="zoom"
            :color="$dark ? 'white' : 'black'"
            :title="$lang.zoom"
            :items="zooms" /><!--
            --><dropdown
            dense
            v-model="throttle"
            icon="speedometer"
            items-max-height="200px"
            width="132px"
            ref="throttle"
            :class="['mx-2']"
            :color="$dark ? 'white' : 'black'"
            :title="$lang.connectionSpeed"
            :items="throttles" /><!--
            --><icon
            @click="portrait = !portrait"
            :title="$lang.orientation(portrait)"
            :name="portrait ? 'crop-portrait' : 'crop-landscape'"
            :size="1.5"
            :class="['cursor-pointer']" />
          </cell>
        </row>
      </table-layout>
      <table-layout :class="[`${baseCss}-breakpoints`, 'box-border', 'cursor-pointer', bgColor]" y-align="middle" x-align="center">
        <row>
          <cell
            @mouseover.native="setBreakpointLabel(breakpoint)"
            @mouseout.native="setBreakpointLabel()"
            @click="setBreakpoint(breakpoint.width)"
            v-for="(breakpoint, index) in breakpoints"
            v-if="index < breakpoints.length - 1"
            :class="['box-border', transition, breakpoint.cssClass, breakpointsRelated.includes(breakpoint.cssClass) ? bgColorHover : null]"
            :title="label(breakpoint)"
            :style="{width: setBreakpointWidth(breakpoint.width)}"
            :key="index">&nbsp;</cell>
          <cell
            @mouseover.native="setBreakpointLabel(breakpoints[6])"
            @mouseout.native="setBreakpointLabel()"
            @click="setBreakpoint(breakpoints[6].width)"
            v-html="breakpointLabel"
            :class="['box-border', transition, breakpoints[6].cssClass, breakpointsRelated.includes(breakpoints[6].cssClass) ? bgColorHover : null]"
            :title="label(breakpoints[6])" :style="{width: setBreakpointWidth(breakpoints[6].width)}" />
          <cell
            @mouseover.native="setBreakpointLabel(breakpoint)"
            @mouseout.native="setBreakpointLabel()"
            @click="setBreakpoint(breakpoint.width)"
            v-for="(breakpoint, index) in breakpointsReversed"
            v-if="index > 0"
            :class="['box-border', transition, breakpoint.cssClass, breakpointsRelated.includes(breakpoint.cssClass) ? bgColorHover : null]"
            :title="label(breakpoint)" :style="{width: setBreakpointWidth(breakpoint.width)}"
            :key="`${index}-reversed`">&nbsp;</cell>
        </row>
      </table-layout>
      <table-layout y-align="top" x-align="center" equal-cells :class="[`${baseCss}-iframe-container`]">
        <row>
          <cell :class="[width === '100%' && height === '100%' ? null : 'pt-6']">
            <iframe
              :style="style"
              :src="url"
              :class="['box-border', `${baseCss}-iframe`, 'inline-block', 'shadow-2xl-up', 'shadow-2xl', 'shadow-3xl', 'shadow-3xl-up', transition]"
              :width="width"
              :height="height" />
          </cell>
        </row>
      </table-layout>
      <reactive-style>
      html, body
      {
        overflow: hidden;
      }
      </reactive-style>
    </template>
  </dialog-box>
</template>
<script>
import zooms from '../helpers/device-emulator-zooms'
import devices from '../helpers/device-emulator-devices'
import throttles from '../helpers/device-emulator-throttles'
import breakpoints from '../helpers/device-emulator-breakpoints'

export default {
  name: 'DeviceEmulator',
  data () {
    return {
      zooms,
      devices,
      breakpoints,
      throttles,
      width: null,
      height: null,
      breakpointLabel: null,
      breakpointSelected: null,
      portrait: true,
      baseCss: 'device-emulator',
      throttle: [0],
      device: [
        'iphone-se'
      ],
      transition: [
        'transition-all',
        'duration-250'
      ],
      zoom: [
        '75%'
      ],
      breakpointsReversed: [],
      breakpointsRelated: []
    }
  },
  computed: {
    style () {
      return {
        transform: `scale(${this.zoom[0]})`
      }
    },
    bgColor () {
      return this.$dark ? 'bg-gray-900' : 'bg-gray-300'
    },
    bgColorHover () {
      return this.$dark ? 'bg-gray-700' : 'bg-gray-400'
    }
  },
  props: {
    url: {
      type: String,
      required: true
    }
  },
  watch: {
    device () {
      this.portrait = true
      if (this.device[0] === 'responsive') {
        this.zoom = ['100%']
      }
    },
    throttle () {
      const throttle = this.throttle[0]
      const key = 'throttle'
      throttle !== 0 ? localStorage.setItem(key, throttle) : localStorage.removeItem(key)
    },
    portrait () {
      const width = this.width
      const height = this.height
      if (this.portrait) {
        this.onDeviceInput()
      } else {
        this.width = height
        this.height = width
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    onDismiss () {
      this.throttle = [0]
      localStorage.removeItem('throttle')
    },
    label (breakpoint) {
      return `${breakpoint.label} - ${breakpoint.width}px`
    },
    setBreakpointWidth (width) {
      switch (width) {
        case 320:
          return `${width}px`
        case 375:
          return `${(width - 320) / 2}px`
        case 425:
          return `${(width - 375) / 2}px`
        case 768:
          return `${(width - 425) / 2}px`
        case 1024:
          return `${(width - 768) / 2}px`
        case 1440:
          return `${(width - 1024) / 2}px`
        default:
          return 'auto'
      }
    },
    init () {
      const breakpoints = [...this.breakpoints]
      this.dialog = true
      this.onDeviceInput()
      this.breakpointsReversed = breakpoints.reverse()
    },
    onDeviceInput () {
      const device = this.getCurrentDevice()
      this.width = device.width
      this.height = device.height
    },
    getCurrentDevice () {
      const devices = this.devices
      const index = devices.findIndex(device => device.value === this.device[0])
      return devices[index]
    },
    setBreakpoint (width) {
      this.width = width
      this.device = [this.devices[0].value]
    },
    setBreakpointLabel (breakpoint) {
      this.breakpointLabel = breakpoint ? this.label(breakpoint) : null
      if (breakpoint) {
        this.breakpointSelected = breakpoint.cssClass
        this.breakpointsRelated = breakpoint.related
      } else {
        this.breakpointSelected = null
        this.breakpointsRelated = []
      }
    }
  }
}
</script>
<style>
.device-emulator .device-emulator-iframe-container
{
  height: calc(100vh - 95px);
}

.device-emulator .device-emulator-iframe
{
  transform-origin: top;
}

.device-emulator .device-emulator-breakpoints .bcq-table-layout-cell
{
  font-size: 11px;
}

.device-emulator .device-emulator-breakpoints .bcq-table-layout-cell:not(:first-of-type):not(:last-of-type)
{
  border-left: solid 1px var(--semi-transparent-light);
  border-right: solid 1px var(--semi-transparent-light);
}
</style>



// WEBPACK FOOTER //
// src/components/device-emulator.vue